<template>
  <v-card>
    <v-card-title> Data Siswa </v-card-title>
    <v-card-text>
      <div align="right">
        <v-btn
          dark
          color="green"
          @click="
            req = {};
            modal.import = true;
          "
          v-if="$root.app.isAdmin"
          class="ml-1 mr-1 mb-2"
        >
          <v-icon>mdi-file</v-icon>
          Import Excel
        </v-btn>
        <v-btn
          dark
          color="blue"
          @click="
            req = {};
            modal.create = true;
          "
          v-if="$root.app.isAdmin"
          class="ml-1 mr-1 mb-2"
        >
          <v-icon>mdi-plus</v-icon>
          Tambah
        </v-btn>
        <v-btn
          dark
          color="red"
          @click="modal.truncate = true"
          v-if="$root.app.isAdmin"
          class="ml-1 mr-1 mb-2"
        >
          <v-icon>mdi-delete-sweep</v-icon>
          Hapus Semua
        </v-btn>
      </div>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-row>
          <v-col lg="4" cols="12">
            <v-autocomplete
              label="Rombel"
              v-model="filter.rombel_id"
              :items="data.rombel"
              @change="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col lg="8" cols="12">
            <v-text-field
              label="Search"
              v-model="filter.search"
              @change="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <button type="submit" hidden="true"></button>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="
          $root.app.isAdmin
            ? [
                {
                  text: 'NIS',
                  value: 'nis',
                },
                {
                  text: 'Nama Siswa',
                  value: 'nama',
                },
                {
                  text: 'Rombel',
                  value: 'rombel',
                },
                {
                  text: 'Status',
                  value: 'status',
                },
                {
                  text: 'Opsi',
                  value: 'actions',
                },
              ]
            : [
                {
                  text: 'NIS',
                  value: 'nis',
                },
                {
                  text: 'Nama Siswa',
                  value: 'nama',
                },
                {
                  text: 'Rombel',
                  value: 'rombel',
                },
                {
                  text: 'Status',
                  value: 'status',
                },
              ]
        "
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.rombel" slot-scope="{ item }">
          {{ item.rombel.rombel }}
        </template>

        <template slot="item.actions" slot-scope="{ item }">
          <v-btn
            icon
            color="blue"
            @click="
              req = item;
              if (item.wali != null) {
                req_wali = item.wali;
              }
              modal.edit = true;
            "
          >
            <v-icon>mdi-pen</v-icon>
          </v-btn>
          <v-btn
            icon
            color="red"
            @click="
              req = item;
              modal.delete = true;
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="modal.create">
      <v-form ref="create" @submit.prevent="store">
        <v-card width="500">
          <v-card-title>Tambah Siswa</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-text-field
              v-model="req.nis"
              placeholder="Masukkan NIS"
              label="NIS"
              :rules="[(v) => !!v || 'nis harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.nama"
              placeholder="Masukkan Nama"
              label="Nama"
              :rules="[(v) => !!v || 'nama harus diisi']"
            ></v-text-field>
            <v-autocomplete
              label="Rombel"
              v-model="req.rombel_id"
              :rules="[(v) => !!v || 'rombel harus dipilih']"
              :items="data.rombel"
            ></v-autocomplete>
            <v-select
              label="Status"
              v-model="req.status"
              :rules="[(v) => !!v || 'status harus dipilih']"
              :items="[
                {
                  value: 'aktif',
                  text: 'Aktif',
                },
                {
                  value: 'nonaktif',
                  text: 'Nonaktif',
                },
              ]"
            ></v-select>

            <v-text-field
              v-model="req_wali.nama"
              placeholder="Masukkan Nama Orang Tua"
              label="Nama Orang Tua"
              :rules="[(v) => !!v || 'nama orang tua harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req_wali.telepon"
              placeholder="Nomor Whatsapp"
              label="No. Whatsapp Orang Tua"
              :rules="[(v) => !!v || 'no. whatsapp harus diisi']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.create = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="modal.edit">
      <v-form ref="edit" @submit.prevent="update">
        <v-card width="500">
          <v-card-title>Edit Siswa</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-text-field
              v-model="req.nis"
              placeholder="Masukkan NIS"
              label="NIS"
              :rules="[(v) => !!v || 'nis harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.nama"
              placeholder="Masukkan Nama"
              label="Nama"
              :rules="[(v) => !!v || 'nama harus diisi']"
            ></v-text-field>
            <v-autocomplete
              label="Rombel"
              v-model="req.rombel_id"
              :rules="[(v) => !!v || 'rombel harus dipilih']"
              :items="data.rombel"
            ></v-autocomplete>
            <v-select
              label="Status"
              v-model="req.status"
              :rules="[(v) => !!v || 'status harus dipilih']"
              :items="[
                {
                  value: 'aktif',
                  text: 'Aktif',
                },
                {
                  value: 'nonaktif',
                  text: 'Nonaktif',
                },
              ]"
            ></v-select>

            <v-text-field
              v-model="req_wali.nama"
              placeholder="Masukkan Nama Orang Tua"
              label="Nama Orang Tua"
              :rules="[(v) => !!v || 'nama orang tua harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req_wali.telepon"
              placeholder="Nomor Whatsapp"
              label="No. Whatsapp Orang Tua"
              :rules="[(v) => !!v || 'no. whatsapp harus diisi']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.edit = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="modal.delete">
      <v-card width="450">
        <v-form @submit.prevent="destroy">
          <v-card-title>Hapus Siswa</v-card-title>
          <v-card-text>Anda yakin menghapus {{ req.nama }}?</v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Hapus</v-btn>
            <v-btn type="button" text color="red" @click="modal.delete = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal.truncate">
      <v-card width="450">
        <v-form @submit.prevent="truncate">
          <v-card-title>Hapus Semua Siswa</v-card-title>
          <v-card-text
            >Anda yakin menghapus data semua siswa? Data siswa akan
            dikosongkan!</v-card-text
          >
          <v-card-actions>
            <v-btn type="submit" text color="blue">Hapus</v-btn>
            <v-btn
              type="button"
              text
              color="red"
              @click="modal.truncate = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal.import">
      <v-card width="500">
        <v-form @submit.prevent="importAction" ref="import">
          <v-card-title>Import Siswa</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <p>
              Unduh contoh format import
              <a :href="contohImport" target="_blank">disini</a>
            </p>
            <v-file-input
              :loading="is.submit"
              :disabled="is.submit"
              clearable
              required
              @change="handleImport"
              label="File"
              hint="Pilih File"
              persistent-hint
              show-size
              accept="application/*"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" color="blue" text>Simpan</v-btn>
            <v-btn type="button" color="red" text @click="modal.import = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        create: false,
        edit: false,
        delete: false,
        import: false,
        truncate: false,
      },
      req: {},
      req_wali: {
        nama: "",
        telepon: "",
      },
      is: {
        loading: true,
        submit: false,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      data: {
        rombel: [],
      },
      contohImport: "",
      req_import: {
        file: "",
      },
    };
  },
  created() {
    this.get();
    this.getData();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    get() {
      this.req = {
        rombel_id: "",
      };
      if (this.filter.rombel_id == null) {
        this.filter.rombel_id = "";
      }
      this.is.loading = true;
      this.$root.app.http.get("/api/siswa", this.filter).then((res) => {
        this.datas = res.data;
        this.contohImport = res.contohImport;
        this.recordsTotal = res.recordsTotal;
        this.is.loading = false;
      });
    },
    getData() {
      this.data.rombel = [];
      this.$root.app.http.get("/api/rombel").then((res) => {
        res.data.forEach((item) => {
          this.data.rombel.push({
            text: item.rombel,
            value: item.id,
          });
        });
      });
    },
    store() {
      this.is.submit = true;
      if (this.$refs.create.validate()) {
        this.req.wali = this.req_wali;
        this.$root.app.http.post("/api/siswa", this.req).then((res) => {
          this.is.submit = false;
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.create = false;
            this.$root.app.notif(res.message);
          }
        });
      }
    },
    update() {
      this.is.submit = true;
      if (this.$refs.edit.validate()) {
        this.req.wali = this.req_wali;
        this.$root.app.http
          .put("/api/siswa/" + this.req.id, this.req)
          .then((res) => {
            this.is.submit = false;
            if (res.error) {
              this.$root.app.notif(res.message[0], true);
            } else {
              this.get();
              this.modal.edit = false;
              this.$root.app.notif(res.message);
            }
          });
      }
    },
    destroy() {
      this.$root.app.http.del("/api/siswa/" + this.req.id).then((res) => {
        if (res.error) {
          this.$root.app.notif(res.message[0], true);
        } else {
          this.get();
          this.modal.delete = false;
          this.$root.app.notif(res.message);
        }
      });
    },
    truncate() {
      this.$root.app.http.del("/api/siswa").then((res) => {
        if (res.error) {
          this.$root.app.notif(res.message[0], true);
        } else {
          this.get();
          this.modal.truncate = false;
          this.$root.app.notif(res.message);
        }
      });
    },
    importAction() {
      if (this.$refs.import.validate()) {
        this.is.submit = true;
        this.$root.app.http
          .post("/api/siswa/import", this.req_import)
          .then((res) => {
            if (res.error) {
              this.$root.app.notif(res.message[0], true);
            } else {
              this.get();
              this.modal.import = false;
              this.$root.app.notif(res.message);
              this.req_import = {
                file: "",
              };
              this.is.submit = false;
            }
          });
      }
    },
    handleImport(val) {
      this.$root.app.toBase64(val, (result) => {
        this.req_import.file = result;
      });
    },
  },
};
</script>
